import { render } from "./Theta_chart.vue?vue&type=template&id=3e47ce17"
import script from "./Theta_chart.vue?vue&type=script&lang=js"
export * from "./Theta_chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__